import { ProveedorToast } from '@reparto/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AvisoVersion } from './componentes/AvisoVersion';
import './estilos.css';

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <ProveedorToast>
      <AvisoVersion />
      <App />
    </ProveedorToast>
  </StrictMode>,
);
